// cpfPaciente,  
// nomePaciente,
// sexoPaciente,
// dataNascimentoPaciente,
// emailPaciente, 
// dddCelularPaciente,
// numeroCelularPaciente, 

const initialState = {
    cpfPaciente: '',
    nomePaciente: '',
    sexoPaciente: '',
    dataNascimentoPaciente: null,
    emailPaciente: '',
    dddCelularPaciente: '', 
    numeroCelularPaciente: ''
}

export default initialState